import React from 'react';
import Content from '../questions/Content';
import Videos from '../videos/Videos';
import Header from '../Header';
import UsersContent from '../questions/UsersContent';
import UsersVideos from '../videos/userVideos'

const Platform = (props) => {
    
    const getComponent = () => {
        switch (props.match.params.type) {
            case "questions":
                return <Content />
            case "videos":
                return <Videos />
            case "userQuestions":
                return <UsersContent />
            case "userVideos":
                return <UsersVideos />
            default:
                return <Content />
        }
    }

    
    return (
        <div>
            <Header history={props.history} />
            {
                getComponent()
            }
        </div>
    );
}

export default Platform;
